import Styles from './WizardTabs.module.scss'

import { WizardTabsProps } from './Types'
import { Chip } from 'components/Chip/Chip'
import { CategoryFilterWrapper } from 'components/Wizards/Catalogue/CategoryFilterWrapper'

const WizardTabs = <T extends string>({ tabs, onSelectTab, selectedTab }: WizardTabsProps<T>) => {
  return (
    <div className={Styles.tabsContainer}>
      <CategoryFilterWrapper>
        {tabs.map((tab) => (
          <Chip
            deletable={false}
            variant="wizardsV3"
            size="lg"
            key={tab.name}
            onPress={() => onSelectTab(tab.name)}
            isSelected={tab.name === selectedTab}
            icon={tab.name === selectedTab ? tab.activeIcon : tab.inactiveIcon}
            preventFocusOnPress
          >
            {tab.label}
          </Chip>
        ))}
      </CategoryFilterWrapper>
    </div>
  )
}

export { WizardTabs }
